import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/main.css';

try {
  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Failed to find the root element');

  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement
  );
} catch (error) {
  console.error('Error rendering app:', error);
  const rootElement = document.getElementById('root');
  if (rootElement) {
    const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred';
    rootElement.innerHTML = `
      <div style="padding: 20px; color: red;">
        Failed to initialize application: ${errorMessage}
      </div>
    `;
  }
}
